import { useSafariPackagesContext } from "provider/SharePackagesProvider";
import React from "react";
import { Accordion } from "react-bootstrap";

const FaqPackage = () => {
  const { packageViewData } = useSafariPackagesContext();

  return (
      <div className="card bg-set accordion-collapse card_bodyPadding">
        <div className="card-body p-3">
          <Accordion defaultActiveKey="0" className="inner_accordion">
            {packageViewData?.faqs && packageViewData?.faqs?.length > 0 ? (
              packageViewData?.faqs?.map((faq, index) => (
                <Accordion.Item eventKey={index.toString()} key={faq.id} className="mb-3">
                  <Accordion.Header>{faq.question}</Accordion.Header>
                  <Accordion.Body>{faq.answer}</Accordion.Body>
                </Accordion.Item>
              ))
            ) : (
              <p>No FAQs available.</p>
            )}
          </Accordion>
        </div>
      </div>
  );
};

export default FaqPackage;

